import { removeSpecialCharacter } from 'modules/shared/validators/ApplicationNameValidation';
import './breadcrumbApplication.scss';
export const BreadcrumbChangeSubheaderTitleEvent = 'BreadcrumbChangeSubheaderTitle';
export class BreadcrumbApplicationController {
    static $inject = ['$rootScope', 'ApplicationService2', '$state', '$scope', 'MessagingHubService'];
    constructor($rootScope, ApplicationService2, $state, $scope, MessagingHubService) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.ApplicationService2 = ApplicationService2;
        this.$state = $state;
        this.$scope = $scope;
        this.MessagingHubService = MessagingHubService;
        this.application = {};
        this.isPipeline = false;
        this.onFinishEditingName = (event) => {
            if (event.detail?.value !== event.detail?.oldValue) {
                this.finishEditingName(event.detail.value.trim());
            }
        };
        this.$scope.$watch(() => {
            return $state.current.name;
        }, (newVal, oldVal) => {
            if (newVal === 'auth.application.detail.pipeline.index') {
                this.onCheckPipeline();
            }
        });
    }
    async onCheckPipeline() {
        if (this.$rootScope.application.shortName) {
            this.application = await this.ApplicationService2.getApplication(this.$rootScope.application.shortName);
            this.isPipeline = this.application.template === 'pipeline';
            this.editingApplication = this.application;
        }
        else {
            this.isPipeline = false;
        }
    }
    async finishEditingName(newApplicationName) {
        if (!newApplicationName || newApplicationName.length === 0) {
            return;
        }
        const cleanedName = removeSpecialCharacter(newApplicationName) ?? removeSpecialCharacter(this.editingApplication.name);
        this.editingApplication.name = cleanedName;
        if (this.editingApplication.name.length > 0) {
            try {
                this.application = this.editingApplication;
                await this.save();
            }
            catch (error) {
                console.error(error);
            }
        }
    }
    async save() {
        const account = await this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/account',
        });
        const newAccount = {
            ...account,
            fullName: this.editingApplication.name,
            photoUri: this.editingApplication.imageUri,
        };
        await this.MessagingHubService.sendCommand({
            method: 'set',
            type: 'application/vnd.lime.account+json',
            uri: '/account',
            resource: newAccount,
        });
        this.$state.reload();
    }
}
BreadcrumbApplicationController.$inject = ['$rootScope', 'ApplicationService2', '$state', '$scope', 'MessagingHubService'];
